export default __webpack_public_path__ + "static/media/instagram_logo.3e532a57.svg";